import { render, staticRenderFns } from "./LKPublicationsCardRecommendationRpshV3IndexMedianas.vue?vue&type=template&id=466516e3&"
import script from "./LKPublicationsCardRecommendationRpshV3IndexMedianas.vue?vue&type=script&lang=js&"
export * from "./LKPublicationsCardRecommendationRpshV3IndexMedianas.vue?vue&type=script&lang=js&"
import style0 from "./LKPublicationsCardRecommendationRpshV3IndexMedianas.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VBtn,VCheckbox})
